<!-- 申请单位签核 -->
<nz-spin nzTip="Loading..." [nzSpinning]="nzSpinning" nzSize="large">
  <div class="main">
    <div class='head clearfix'>
      <!-- 项目管理签核 部级签核 概算签核 -->
      <div class="head-first" *ngFor="let item1 of msgSign"
        [ngClass]="{'activeBtnFirst': activeBtnFirst === item1.text}"
        (click)="conditionFirstQuery(item1.text,item1.num)">
        <p>
          {{ item1.text | translate }}
          <!-- 有待签核时才显示小红点 -->
          <nz-badge *ngIf="item1.value==='step1' && step1WaittingCount > 0" nzStatus="error"></nz-badge>
          <nz-badge *ngIf="item1.value==='step2' && step2WaittingCount > 0" nzStatus="error"></nz-badge>
          <nz-badge *ngIf="item1.value==='step10' && step9WaittingCount + step10WaittingCount > 0" nzStatus="error">
          </nz-badge>
        </p>
      </div>
      <div class="head-second">
        <!-- 一般工程 专案工程 -->
        <div class="div-first" *ngIf="step > 2">
          <div *ngFor="let item2 of dubgetSign" [ngClass]="{'activeBtnSecond': activeBtnSecond === item2.text}"
            (click)="conditionSecondQuery(item2.text,item2.num)">
            <p>
              {{ item2.text | translate }}
              <!-- 有待签时才显示小红点 -->
              <nz-badge class="badge" *ngIf="item2.value==='0' && step9WaittingCount > 0" nzStatus="error">
              </nz-badge>
              <nz-badge class="badge" *ngIf="item2.value==='1' && step10WaittingCount > 0" nzStatus="error">
              </nz-badge>
            </p>
          </div>
        </div>
        <!-- 待签核数量 已签核数量 -->
        <div class="div-second">
          <div *ngFor="let item3 of itemStatus" [ngClass]="{'activeBtnThird': activeBtnThird === item3.text}"
            (click)="conditionThirdQuery(item3.text,item3.num)">
            <p>{{ item3.text | translate }}</p>
            <ng-container *ngIf="step <= 2;else normal">
              <p class="p-second" style="font-size: 15px;">{{ countStatusData[step][item3.value] }}</p>
            </ng-container>
            <ng-template #normal>
              <p *ngIf="projectType !== undefined && countStatusDataByProjectType[step][projectType][item3.value] !== undefined" class="p-second" style="font-size: 15px;">{{ countStatusDataByProjectType[step][projectType][item3.value] }}</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="main-body">
      <!-- 日期搜索 -->
      <div class="time-search">
        <app-timesearch (submitEvent)="submitEvent($event)"></app-timesearch>
      </div>
      <!-- 单据item -->
      <div class="application-item">
        <div class="list-item" *ngFor="let item of this.listItem">
          <app-listitem [listItem]="item" [url]="url" [activeBtn]="activeBtnThird" [step]="step"></app-listitem>
        </div>
      </div>
      <!-- 分页 -->
      <app-pagination [total]="total" [pageSize]="pageSize" (pageIndex)="pageIndexChange($event)"></app-pagination>
    </div>
  </div>
</nz-spin>